export enum ShareOptions {
  LinkedIn = 'LinkedIn',
  Facebook = 'Facebook',
  Pinterest = 'Pinterest',
  Twitter = 'Twitter',
  Email = 'Email',
}

export enum NetworkUrls {
  LinkedIn = 'https://www.linkedin.com/shareArticle',
  Facebook = 'https://www.facebook.com/sharer/sharer.php',
  Pinterest = 'https://pinterest.com/pin/create/button/',
  Twitter = 'https://twitter.com/share',
  Email = 'mailto:',
}

export type SocialOpts = LinkedInOpts | FacebookOpts | PinterestOpts | TwitterOpts | EmailOpts;

type LinkedInOpts = {
  url: string;
  mini: boolean;
  title?: string;
  summary?: string;
  source?: string;
};

type FacebookOpts = {
  u: string;
  quote?: string;
  hashtag?: string;
};
type PinterestOpts = {
  url: string;
  media?: string;
  description?: string;
};
type TwitterOpts = {
  url: string;
  text?: string;
  hashtags?: string;
};
type EmailOpts = {
  subject?: string;
  body?: string;
  separator?: string;
};
